import Property from 'components/PropertyPage/PropertyLayout';
import { wrapper } from 'pages/_app.page';
import { fetchPropertySuccess } from 'store/property/propertyActions';
import { fetchPropertyDetails } from 'lib/clients/fetchPropertyDetails';
import { sanitizeProperty } from 'lib/sanitize';
import isEqual from 'lodash/isEqual';
import queryString from 'query-string';
import authenticateUser from 'lib/user/authenticateUser';
import { setLoading } from 'store/search/searchActions';

const getPropertyId = (propertyId) => {
  const match = propertyId.match(/([0-9]*)/);
  return match ? match[1] : null;
};

export const getServerSideProps = wrapper.getServerSideProps((store) => async ({ req, query: rawQuery }) => {
  await authenticateUser(req.cookies, store.dispatch, store.getState());

  const { propertyid, ...query } = rawQuery;
  const propertyId = getPropertyId(propertyid);

  const sanitizedQuery = sanitizeProperty(query);
  const didSanitize = !isEqual(query, sanitizedQuery);

  if (didSanitize) {
    const newQueryString = queryString.stringify(sanitizedQuery);
    return {
      redirect: {
        permanent: false,
        destination: `/properties/${propertyid}?${newQueryString}`,
      },
    };
  }

  try {
    const { property } = await fetchPropertyDetails({ propertyId, cookie: req?.headers?.cookie });
    store.dispatch(fetchPropertySuccess({ property }));
    store.dispatch(setLoading(false));
  } catch (error) {
    return {
      notFound: true,
    };
  }

  return {
    props: {},
  };
});

export default Property;
